import $ from 'jquery';

$(function () {
  var $createCadminAccountButton = $('#js-create-cadmin-account-button');
  var $container = $('#image-container');
  var $passwordMessage = $('#password-match-message');

  var passwordsValid = function () {
    var password = $('#js-cadmin-set-password').val();
    if (password.length == 0) {
      return false;
    }
    return password === $('#js-cadmin-confirm-password').val();
  };

  $('.js-set-cadmin-password').keyup(function () {
    if (passwordsValid()) {
      $createCadminAccountButton.removeClass('hidden');
      $passwordMessage.addClass('hidden');
      $container.addClass('unlocked');
    } else {
      $createCadminAccountButton.addClass('hidden');
      $passwordMessage.removeClass('hidden');
      $container.removeClass('unlocked');
    }
  });
});
